<nb-card class="custom-card">
    <nb-card-body>
        <div class="row">
            <div class="col-sm-7">
                <h2>Change Password</h2>
                <form [formGroup]="passwordForm">
                    <div class="form-group">
                        <label for="newPassword"><strong>Password</strong></label>
                        <input [type]="showPassword ?   'password':'text'" class="form-control"
                            placeholder="Enter New Password" formControlName="password" nbInput />
                        <button class="toggle_password1" type="button" *ngIf="passwordForm.get('password').value !== ''"
                            (click)="togglePasswordVisibility()">
                            <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"
                                aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="form-group">
                        <label for="newPassword"><strong>Confirm Password</strong></label>
                            <input id="newPassword" [type]="showPassword2 ? 'password':'text'" class="form-control"
                            placeholder="Confirm Password" formControlName="confirmpassword" nbInput />
                        <button class="toggle_password2" type="button" *ngIf="passwordForm.get('confirmpassword').value !== ''"
                            (click)="togglePasswordVisibility2()">
                            <i class="fa" [class.fa-eye]="!showPassword2" [class.fa-eye-slash]="showPassword2"
                                aria-hidden="true"></i>
                        </button>
                    </div>
                </form>
            </div>

        </div>
        <div class="row mt-4">
            <div class="col-sm-10">
                <button style="float: right;" type="submit" (click)="changePassword()" style="float: right; "
                    class="btn btn-primary px-4">
                    Save
                </button>
            </div>
            <div class="col-sm-2">
                <button type="submit" (click)="onCancel()" style="float: right; " class="btn btn-danger px-4">
                    Cancel
                </button>
            </div>
        </div>

        <!-- <div class="col-sm-6">
            <button type="submit" (click)="changePassword()" style="float: right; margin-right: 20px"
            class="btn btn-primary px-4">
            Save
        </button>
        </div> -->
    </nb-card-body>
</nb-card>